import { Client } from "./_clientService";

async function getDailyRewards() {
  try {
    let path = "/daily-reward/list";
    const resp = await new Client({ path }).post();

    return resp;
  } catch (error) {
    throw error;
  }
}

async function getDailyRewardsInfo(dailyRewardId: any) {
  try {
    const resp = await new Client({
      path: "/daily-reward/info",
      payload: {
        dailyRewardId: dailyRewardId,
      },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function createDailyReward(dailyReward: any) {
  try {
    const resp = await new Client({
      path: "/daily-reward/create",
      payload: dailyReward,
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function updateDailyReward(dailyReward: any) {
  try {
    const resp = await new Client({
      path: "/daily-reward/update",
      payload: { ...dailyReward },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

export async function deleteDailyReward(dailyRewardId: any) {
  const resp = await new Client({
    path: "daily-reward/delete",
    payload: { dailyRewardId },
  }).post();

  return resp;
}

export {
  getDailyRewards,
  getDailyRewardsInfo,
  createDailyReward,
  updateDailyReward,
};
